import { APPLICATION_STATE, MessagingSystemUserIds } from 'shared-lib'
import { ISendMessageDto } from './automation.dto'
import { ISendMessageFormData } from './job-automation.model'

export type ICultureIndexFormData = {
  enabled: boolean
  immediate?: boolean
  newSwimlane: APPLICATION_STATE | null
  senderId: string
  initialMessage: ISendMessageFormData
  followUp: ISendMessageFormData
  warning: ISendMessageFormData
}

export const cultureIndexDefaults: ICultureIndexFormData = {
  enabled: false,
  newSwimlane: null,
  senderId: MessagingSystemUserIds.hiring_team,
  initialMessage: {
    enabled: false,
    message:
      'As part of the application process for this job, we would like for you to please complete a Culture Index survey. You should have received a notification about this and should see an option on your application to complete the survey. Please complete this survey and send it back to continue forward in the application process.',
    senderId: MessagingSystemUserIds.hiring_team,
    delayDuration: 10,
    delayUnits: 'minutes',
  },
  followUp: {
    enabled: false,
    message:
      'We wanted to send you a reminder that as part of the application process for this job, we would like for you to please complete a Culture Index survey. You should have received a notification about this and should see an option on your application to complete the survey. Please complete this survey and send it back to continue forward in the application process.',
    senderId: MessagingSystemUserIds.hiring_team,
    delayDuration: 10,
    delayUnits: 'minutes',
  },
  warning: {
    enabled: false,
    message:
      'We wanted to send you a final reminder that as part of the application process for this job, we would like for you to please complete a Culture Index survey. You should have received a notification about this and should see an option on your application to complete the survey. Please complete this survey and send it back to continue forward in the application process.',
    senderId: MessagingSystemUserIds.hiring_team,
    delayDuration: 10,
    delayUnits: 'minutes',
  },
}
export interface ICultureIndexDto {
  enabled: boolean
  immediate?: boolean
  newSwimlane: APPLICATION_STATE | null
  senderId: string
  initialMessage: ISendMessageDto
  followUp: ISendMessageDto
  warning: ISendMessageDto
}
